import React, { ButtonHTMLAttributes, ReactNode } from 'react';
import { VariantProps } from 'class-variance-authority';
import cn from '@/utils/cn';
import { buttonVariants } from './buttonVariants';

interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  children?: ReactNode;
  childrenClassName?: string;
}

const ButtonComponent: React.FC<ButtonProps> = ({
  children,
  variant,
  size,
  fontSize,
  className,
  childrenClassName,
  disabled,
  ...props
}) => {
  // The 'pill' size carries its own standard padding on the button itself (see buttonVariants) -
  // every other size keeps padding on this inner span instead, so this is the one place variant
  // padding and span padding would otherwise double up.
  const isPill = size === 'pill';

  return (
    <button
      data-testid="StyledButton"
      disabled={disabled}
      className={cn(
        'group flex items-center text-center relative justify-center',
        buttonVariants({ variant: disabled ? 'disabled' : variant, size, fontSize, className })
      )}
      {...props}>
      <span
        className={cn(
          'transition-all duration-200 rounded-md items-center flex gap-2',
          isPill ? 'w-full justify-center' : 'text-sm px-4 py-2',
          childrenClassName
        )}>
        {children}
      </span>
    </button>
  );
};

export default ButtonComponent;
